import React, { Component } from 'react';
import styled from 'styled-components';
import checkmark from './Checkmark.png';

const Container = styled.div`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  background: #FFFFFF;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 20px;
  margin-right: 20px;
  max-height: 186px;
`;

const Title = styled.h3`
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #4A4A4A;
  `;

const Option = styled.label`
  display: flex;
  margin: 10px 0px;`;

const Checkbox = styled.input`
    display: none;

    &:checked ~ div {
      border-color: #2196F3;
      background-image: url(${checkmark});
      background-repeat: no-repeat;
      background-position: center center;
    }
  `;

const Fakebox = styled.div`
  border: 1px solid #9ABBCE;
  box-sizing: border-box;
  border-radius: 2px;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  `;

const Content = styled.p`
  font-size: 13px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #4A4A4A;
  margin: 0px;`;


interface Sidemenuprops {
  options: {
    [index: string]: any;
  },
  change: any;
}




export default class Sidemenu extends Component<Sidemenuprops> {
  render() {
    return (
      <Container>
          <Title> Количество пересадок </Title>
          {
            Object.keys(this.props.options).map(option => {
              return(
                <Option key={option}>
                  <Checkbox data-setting={'setting'} data-key={option} onChange={this.props.change} checked={this.props.options[option].checked} type="checkbox"/>
                  <Fakebox/>
                  <Content>
                    { option }
                  </Content>
                </Option>
              );
            })
          }
      </Container>
    )
  }
};